import Options from "@/providers/api/resources/Options"

export default {
  created () {
    this.$api.register({ FilterOptions: Options }, this._uid)
    this.$api.Options = this.$api.FilterOptions
  }
}
